import type { TableQueryConfig } from "@/shared/lib/data-table/table-query";
import { MinistryStatus } from "@/features/church/config/ministries/types/ministry.types";

export const ministryTypesTableQueryConfig: TableQueryConfig = {
  id: "church-config-ministry-types",
  search: {
    placeholderKey: "searchPlaceholder",
    debounceMs: 300,
    className: "w-full max-w-sm",
  },
  defaultSortBy: "updatedAt",
  defaultSortOrder: "desc",
  filters: [
    {
      id: "status",
      type: "select",
      key: "status",
      labelKey: "status",
      options: {
        type: "static",
        items: [
          { value: "", labelKey: "allStatuses" },
          { value: MinistryStatus.ACTIVE, labelKey: "active" },
          { value: MinistryStatus.INACTIVE, labelKey: "inactive" },
        ],
      },
    },
  ],
};
